import React from 'react'
import {Errors} from 'startlibs/lib/form'

class FakeForm {
  constructor(actionKey,errors) {
    this.actionKey = actionKey
    this.errors = errors
  }
  connector = {getActionKey: ()=>this.actionKey}
  meta = {}
}
const emptyFakeForm = new FakeForm("",{})

export const SimpleErrors = ({action,errors}) => errors ? <Errors className="errorsContainer" form={new FakeForm(action.toString(),errors)} /> : null


// WEBPACK FOOTER //
// ./~/report-components/src/components/SimpleErrors.jsx